document.addEventListener("DOMContentLoaded", function () {
    // eslint-disable-next-line no-unused-vars,no-undef
    const accordion = new AccordionPlugin();
});
